<div class="paged-table_table-container">
  <ng-container *ngTemplateOutlet="pagedTable; context: { dataSource: filteredDataSource }"></ng-container>
</div>
@if (!hidePagination) {
  <div class="paged-table-pagination">
    <button [disabled]="beforeDisabled" class="pagination" (click)="reduceToMinPages()" type="button" mat-icon-button>
      <mat-icon>first_page</mat-icon>
    </button>
    <button [disabled]="beforeDisabled" class="pagination before" (click)="reducePages()" type="button" mat-icon-button>
      <mat-icon>navigate_before</mat-icon>
    </button>
    <div class="paged-table-pagination-pages"> {{ selectedPage }}&nbsp;&nbsp;of&nbsp;&nbsp;{{ totalPages }} </div>
    <button [disabled]="nextDisabled" class="pagination" (click)="incrementPages()" type="button" mat-icon-button>
      <mat-icon>navigate_next</mat-icon>
    </button>
    <button [disabled]="nextDisabled" class="pagination" (click)="incrementToMaxPages()" type="button" mat-icon-button>
      <mat-icon>last_page</mat-icon>
    </button>
  </div>
}
